<template>
  <div class="relation">
    <iframe
      :width="windowW"
      height="100%"
      :src="flowSrc"
      class="el-frame-iframe"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "relationship",
  data() {
    return {
      flowSrc: ""
    };
  },
  mounted() {
    this.flowSrc = this.$router.history.current.query.flowSrc;
  },
  computed: {
    windowW() {
      return `${document.body.clientWidth - 50}px`;
    }
  }
};
</script>

<style scoped>
.relation {
  height: calc(100vh - 70px);
}
.el-frame-iframe {
  border: medium none;
}
/deep/.iframeBody {
  margin-rop: 0 !important;
}
</style>
